<template>
  <div class="insurance">
    <HeroBanner
        :background-image="bannerImage"
        title="분실파손보험"
        sub-title="보청기 구매 후 분실파손 보험 가입 시 <br>
        구매 기간에 따라 할인가로<br>
        재구매 할 수 있습니다."
    />

    <div class="insurance-content">
      <!-- 제목 -->
      <h2 class="main-title">분실파손보험</h2>

      <div class="insurance-img">
        <img src="@/assets/images/banners/03-04-img-1.png" width="425" alt="" srcset="@/assets/images/banners/03-04-img-1@2x.png">
      </div>
      <!-- 정책 설명 -->
      <div class="policy-list">
        <p class="policy-item">A. 보청기 구매 후, 180일 이내 분실파손 시<br>&nbsp;&nbsp;&nbsp;&nbsp;처음 구매 금액의 60% 금액으로 구매 가능</p>
        <p class="policy-item">B. 보청기 구매 후, 1년 이내 분실파손 시<br>&nbsp;&nbsp;&nbsp;&nbsp;처음 구매 금액의 80% 금액으로 구매 가능</p>
        <p class="policy-item">C. 보청기 구매 후, 1년이 지나면<br>&nbsp;&nbsp;&nbsp;&nbsp;다비치 히어링 보청기 가격정찰제 금액으로 구매 가능</p>
      </div>

      <!-- 프로모션 안내 -->
      <div class="promotion-info">
        <h3 class="promotion-title">※ 프로모션 제품 분실파손 적용 안내</h3>
        <p class="promotion-text">- 모든 프로모션 기간에 구매한 보청기는 분실파손 정책 적용<br>&nbsp;&nbsp;시 기본 정찰가 기준으로 할인 적용됨<br><br>- 가격 정찰제 보청기 구매 제품에 한하여 적용 가능<br>&nbsp;&nbsp;(보장구 품목 적용 불가)</p>
        <p class="promotion-example">(적용 예시)<br>- 180일 이내에 분실한 경우,<br>&nbsp;&nbsp;원래 클래식급 가격 280만원의 60% 가격<br>&nbsp;&nbsp;(280만원에서 40% 할인)으로 재구매 가능<br><br>- 365일 이내에 분실한 경우,<br>&nbsp;&nbsp;원래 클래식급 280만원의 80% 가격<br>&nbsp;&nbsp;(280만원에서 20%할인)으로 재구매 가능</p>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from '@/assets/images/heros/03-top-img.png';

export default {
  name: 'Insurance',
  components: {HeroBanner},
  data() {
    return {
      bannerImage: [bannerBg],
    };
  }
};
</script>

<style scoped lang="scss">
.insurance-img{
  padding: 0 36px;
  img{
    width: 100%;
  }

}
.insurance {
  .insurance-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 56px 0 80px;
    gap: 43px;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    background: #FFFFFF;

    .main-title {
      //width: 425px;
      max-width: 100%;
      height: 40px;
      font-family: 'Noto Sans KR', sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 26px;
      line-height: 40px;
      display: flex;
      align-items: center;
      letter-spacing: -1.11607px;
      color: #222222;
      margin: 0;
      padding: 0 36px;
      box-sizing: border-box;
    }

    .timeline-diagram {
      position: relative;
      //width: 425px;
      max-width: 100%;
      height: 182px;
      padding: 0 36px;
      box-sizing: border-box;

      // 곡선 라인 A-B
      .line-ab {
        position: absolute;
        width: 137.87px;
        height: 28px;
        left: 21.13px;
        top: 103px;
        border: 2px solid #0056AA;
        border-bottom: none;
        border-radius: 70px 70px 0 0;
      }

      // 곡선 라인 B-C
      .line-bc {
        position: absolute;
        width: 137.87px;
        height: 28px;
        left: 159px;
        top: 103px;
        border: 2px solid #0056AA;
        border-bottom: none;
        border-radius: 70px 70px 0 0;
      }

      // 수직 라인들
      .vertical-line {
        position: absolute;
        width: 0px;
        height: 38px;
        border: 2px solid #888888;

        &.line-a {
          left: 21px;
          top: 113.25px;
        }

        &.line-b {
          left: 159px;
          top: 113.25px;
        }

        &.line-c {
          left: 297px;
          top: 113.25px;
        }
      }

      // 수평 기준선
      .horizontal-baseline {
        position: absolute;
        width: 425px;
        height: 0px;
        left: 0px;
        top: 132px;
        border: 2px solid #888888;
      }

      // 화살표 라인
      .line-c-arrow {
        position: absolute;
        width: 140.5px;
        height: 0px;
        left: 302px;
        top: 121.5px;
        border: 2px solid #222222;

        &::after {
          content: '';
          position: absolute;
          right: -10px;
          top: -6px;
          width: 0;
          height: 0;
          border-left: 10px solid #222222;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
        }
      }

      // 포인트 원들
      .point {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0px 10px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        font-family: 'Noto Sans KR', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 32px;
        letter-spacing: -0.535714px;
        color: #FFFFFF;

        &.point-a {
          left: 74px;
          top: 83px;
          background: #0056AA;
        }

        &.point-b {
          left: 211.87px;
          top: 83px;
          background: #0056AA;
        }

        &.point-c {
          left: 359px;
          top: 83px;
          background: #222222;
        }
      }

      // 레이블들
      .label {
        position: absolute;
        font-family: 'Noto Sans KR', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 30px;
        display: flex;
        align-items: center;
        letter-spacing: -0.04em;
        color: #888888;

        &.label-a {
          width: 84px;
          height: 30px;
          left: 20px;
          top: 152px;
        }

        &.label-b {
          width: 98px;
          height: 30px;
          left: 159px;
          top: 152px;
        }

        &.label-c {
          width: 82px;
          height: 30px;
          left: 297px;
          top: 152px;
        }
      }
    }

    .policy-list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0 36px;
      gap: 16px;
      //width: 425px;
      max-width: 100%;
      box-sizing: border-box;

      .policy-item {
        width: 100%;
        font-family: 'Noto Sans KR', sans-serif;
        font-style: normal;
        font-weight: 350;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: -0.02em;
        color: #222222;
        margin: 0;
      }
    }

    .promotion-info {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0 36px;
      gap: 16px;
      //width: 425px;
      max-width: 100%;
      box-sizing: border-box;

      .promotion-title {
        width: 100%;
        //height: 40px;
        font-family: 'Noto Sans KR', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 40px;
        letter-spacing: -0.05em;
        color: #222222;
        margin: 0;
      }

      .promotion-text {
        width: 100%;
        font-family: 'Noto Sans KR', sans-serif;
        font-style: normal;
        font-weight: 350;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: -0.04em;
        color: #222222;
        margin: 0;
      }

      .promotion-example {
        width: 100%;
        font-family: 'Noto Sans KR', sans-serif;
        font-style: normal;
        font-weight: 350;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: -0.02em;
        color: #222222;
        margin: 0;
      }
    }
  }

  //@media (max-width: 768px) {
  //  .insurance-content {
  //    padding: 40px 0 60px;
  //    gap: 36px;
  //
  //    .main-title {
  //      width: 100%;
  //      font-size: 24px;
  //      line-height: 36px;
  //      padding: 0 16px;
  //    }
  //
  //    .timeline-diagram {
  //      width: 100%;
  //      height: 160px;
  //      padding: 0 16px;
  //
  //      .line-ab,
  //      .line-bc {
  //        width: 120px;
  //        height: 24px;
  //        top: 90px;
  //      }
  //
  //      .line-ab {
  //        left: 16.13px;
  //      }
  //
  //      .line-bc {
  //        left: 136px;
  //      }
  //
  //      .vertical-line {
  //        height: 32px;
  //        top: 100px;
  //
  //        &.line-a {
  //          left: 16px;
  //        }
  //
  //        &.line-b {
  //          left: 136px;
  //        }
  //
  //        &.line-c {
  //          left: 256px;
  //        }
  //      }
  //
  //      .horizontal-baseline {
  //        width: 100%;
  //        top: 115px;
  //      }
  //
  //      .line-c-arrow {
  //        width: 100px;
  //        left: 261px;
  //        top: 106px;
  //      }
  //
  //      .point {
  //        width: 28px;
  //        height: 28px;
  //        font-size: 16px;
  //        line-height: 28px;
  //
  //        &.point-a {
  //          left: 58px;
  //          top: 72px;
  //        }
  //
  //        &.point-b {
  //          left: 178px;
  //          top: 72px;
  //        }
  //
  //        &.point-c {
  //          left: 298px;
  //          top: 72px;
  //        }
  //      }
  //
  //      .label {
  //        font-size: 16px;
  //        line-height: 26px;
  //        top: 135px;
  //
  //        &.label-a {
  //          left: 16px;
  //          width: 75px;
  //        }
  //
  //        &.label-b {
  //          left: 136px;
  //          width: 88px;
  //        }
  //
  //        &.label-c {
  //          left: 256px;
  //          width: 74px;
  //        }
  //      }
  //    }
  //
  //    .policy-list {
  //      width: 100%;
  //      padding: 0 16px;
  //      gap: 14px;
  //
  //      .policy-item {
  //        font-size: 16px;
  //        line-height: 26px;
  //      }
  //    }
  //
  //    .promotion-info {
  //      width: 100%;
  //      padding: 0 16px;
  //      gap: 14px;
  //
  //      .promotion-title {
  //        font-size: 20px;
  //        line-height: 36px;
  //      }
  //
  //      .promotion-text,
  //      .promotion-example {
  //        font-size: 16px;
  //        line-height: 26px;
  //      }
  //    }
  //  }
  //}
  //
  //@media (max-width: 450px) {
  //  .insurance-content {
  //    padding: 30px 0 50px;
  //    gap: 30px;
  //
  //    .main-title {
  //      font-size: 22px;
  //      line-height: 32px;
  //      padding: 0 12px;
  //    }
  //
  //    .timeline-diagram {
  //      height: 140px;
  //      padding: 0 12px;
  //
  //      .line-ab,
  //      .line-bc {
  //        width: 100px;
  //        height: 20px;
  //        top: 80px;
  //      }
  //
  //      .line-ab {
  //        left: 12.13px;
  //      }
  //
  //      .line-bc {
  //        left: 112px;
  //      }
  //
  //      .vertical-line {
  //        height: 28px;
  //        top: 88px;
  //
  //        &.line-a {
  //          left: 12px;
  //        }
  //
  //        &.line-b {
  //          left: 112px;
  //        }
  //
  //        &.line-c {
  //          left: 212px;
  //        }
  //      }
  //
  //      .horizontal-baseline {
  //        top: 100px;
  //      }
  //
  //      .line-c-arrow {
  //        width: 85px;
  //        left: 217px;
  //        top: 92px;
  //
  //        &::after {
  //          right: -8px;
  //          top: -5px;
  //          border-left: 8px solid #222222;
  //          border-top: 5px solid transparent;
  //          border-bottom: 5px solid transparent;
  //        }
  //      }
  //
  //      .point {
  //        width: 26px;
  //        height: 26px;
  //        font-size: 15px;
  //        line-height: 26px;
  //
  //        &.point-a {
  //          left: 49px;
  //          top: 62px;
  //        }
  //
  //        &.point-b {
  //          left: 149px;
  //          top: 62px;
  //        }
  //
  //        &.point-c {
  //          left: 249px;
  //          top: 62px;
  //        }
  //      }
  //
  //      .label {
  //        font-size: 14px;
  //        line-height: 22px;
  //        top: 118px;
  //
  //        &.label-a {
  //          left: 12px;
  //          width: 70px;
  //        }
  //
  //        &.label-b {
  //          left: 112px;
  //          width: 80px;
  //        }
  //
  //        &.label-c {
  //          left: 212px;
  //          width: 68px;
  //        }
  //      }
  //    }
  //
  //    .policy-list {
  //      padding: 0 12px;
  //      gap: 12px;
  //
  //      .policy-item {
  //        font-size: 15px;
  //        line-height: 24px;
  //      }
  //    }
  //
  //    .promotion-info {
  //      padding: 0 12px;
  //      gap: 12px;
  //
  //      .promotion-title {
  //        font-size: 18px;
  //        line-height: 32px;
  //      }
  //
  //      .promotion-text,
  //      .promotion-example {
  //        font-size: 15px;
  //        line-height: 24px;
  //      }
  //    }
  //  }
  //}
}
</style>
